<style scoped>
form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 700px;
  margin: 20px auto;
}

input, textarea {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 10px;

  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.status-success {
  color: green;
}

.status-fail {
  color: red;
}
.status-default {
  color: orange; /* 或其他颜色 */
}
ul {
  list-style-type: none;
  padding: 0;
}

.el-form {
  max-width: none; /* 移除最大宽度限制 */
}
</style>
<script>
import axios from 'axios';

export default {
  name: "OneClick",
  data() {
    return {
      formData: {
        gameName: '',
        configData: ''
      },
      configStatus:0,
      valueGame: "",
      optionsGame: [],
      tasks: [],
      tasks2: [],
      combinedTasks: [],
      combinedTableData: [],
      oneClickFormData: {
        gameName: '',
        scheduleIndex: '',
        topPercentStart: '',
        topPercentEnd: '',
        oneBeginCount: ''
      }, optionsGame2: [],
      taskFormData: {

        gameName: '',
        scheduleIndex: '',
        timeRange: '',
        filterMissingBalanceField: true,
        rangeConfigs: [
          {
            topPercentStart: '',
            topPercentEnd: '',
            oneBeginCount: '',
            beginType: 0
          }
        ]
      },
      dialogVisible: false,
      drawerVisible: false,
      logsData: [],         // 日志数据
      logDateRange: [],
      currentPage: 1,       // 当前页码
      pageSize: 20,         // 每页显示条数
      totalLogs: 0,
      expandedRows: [],
      searchKeyword: '', // 新增搜索关键字
      closePreviewVisible: false,
      closePreviewLoading: false,
      closeExecuteLoading: false,
      closePreviewData: null,
      closePreviewRow: null,
      openPreviewVisible: false,
      openPreviewLoading: false,
      openExecuteLoading: false,
      openPreviewData: null,
      openPreviewRow: null,
      openExecuteResult: null,
      operationMode: 'CONSOLE',
      operationModeSaving: false,
    };
  }, computed: {
    // 根据名字搜索过滤数据
    filteredTableData() {
      if (!this.searchKeyword.trim()) {
        return this.combinedTableData;
      }
      const keyword = this.searchKeyword.toLowerCase().trim();
      return this.combinedTableData.filter(item => {
        return item.gameName && item.gameName.toLowerCase().includes(keyword);
      });
    },
    closePreviewDetails() {
      const details = this.closePreviewData && this.closePreviewData.details;
      return Array.isArray(details) ? details : [];
    },
    openPreviewDetails() {
      const details = this.openPreviewData && this.openPreviewData.details;
      return Array.isArray(details) ? details : [];
    },
    openExecuteDetails() {
      const details = this.openExecuteResult && this.openExecuteResult.details;
      return Array.isArray(details) ? details : [];
    },
    openExecuteAlertType() {
      if (!this.openExecuteResult) {
        return 'info';
      }
      if (this.openExecuteResult.status === 'SUCCESS') {
        return 'success';
      }
      if (this.openExecuteResult.status === 'PARTIAL_SUCCESS') {
        return 'warning';
      }
      return 'error';
    },
    openExecuteSummary() {
      if (!this.openExecuteResult) {
        return '';
      }
      const successCount = this.openExecuteResult.successCount || 0;
      const failedCount = this.openExecuteResult.failedCount || 0;
      const message = this.openExecuteResult.errorMessage || this.openExecuteResult.message || '';
      return `开启完成：成功 ${successCount} 个，失败 ${failedCount} 个${message ? '，' + message : ''}`;
    }
  },
  methods: {

    async loadOperationMode() {
      try {
        const response = await this.$axios.get('/schedule/operationMode');
        if (!response.data || response.data.success !== true) {
          throw new Error((response.data && response.data.msg) || '读取失败');
        }
        const data = response && response.data ? response.data.data : null;
        this.operationMode = data && data.mode === 'OFFICIAL' ? 'OFFICIAL' : 'CONSOLE';
      } catch (error) {
        this.operationMode = 'CONSOLE';
        console.error('读取一键起量操作接口失败:', error);
      }
    },
    async changeOperationMode(mode) {
      const previousMode = mode === 'OFFICIAL' ? 'CONSOLE' : 'OFFICIAL';
      this.operationModeSaving = true;
      try {
        const response = await this.$axios.post('/schedule/operationMode', { mode });
        if (!response.data || response.data.success !== true) {
          throw new Error((response.data && response.data.msg) || '切换失败');
        }
        const data = response && response.data ? response.data.data : null;
        this.operationMode = data && data.mode === 'OFFICIAL' ? 'OFFICIAL' : 'CONSOLE';
        this.$message.success(`操作接口已切换为${this.operationMode === 'OFFICIAL' ? '腾讯官方API' : '投放后台接口'}`);
      } catch (error) {
        this.operationMode = previousMode;
        this.$message.error('操作接口切换失败');
        console.error('切换一键起量操作接口失败:', error);
      } finally {
        this.operationModeSaving = false;
      }
    },

    async toggleSchedule(row) {

      this.$axios
          .get('/schedule/changeStatus/'+row.taskId, {})
          .then(successResponse => {

            this.$message.success('任务状态切换成功！');

            this.fetchTasks()

          }).then(() => {



      })




    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.findLogs(); // 重新加载数据
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.findLogs(); // 重新加载数据
    },
    handleExpandChange(row, expandedRows) {
      if (Array.isArray(expandedRows)) {
        this.expandedRows = expandedRows.map(item => item.taskId);
      } else {
        console.warn('expandedRows is not an array:', expandedRows);
        this.expandedRows = [];
      }
    },
    openAddTaskDialog() {
      this.$axios
          .get('/toufangWx/data/findName', {})
          .then(successResponse => {

            this.optionsGame2 = successResponse.data.data

          })
      this.taskFormData = {
        gameName: '',
        scheduleIndex: '',
        timeRange: '',
        filterMissingBalanceField: true,
        rangeConfigs: [
          {
            topPercentStart: '',
            topPercentEnd: '',
            oneBeginCount: '',
            beginType: 0
          }
        ]
      }
      this.dialogVisible = true; // 打开对话框
    },
    async delJob(row) {
      try {
        const response = await axios.get('/schedule/delJob', {
          params: {
            gameName: row.gameName,
            scheduleIndex: row.scheduleIndex,
            id: row.taskId
          }
        }).then(response => {

          this.fetchTasks() ;
          console.log('删除任务成功:', response.data);

          this.$message.success('删除任务成功！');
        });

      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    },async delJobAll(row) {
      try {
        const response = await axios.get('/schedule/delJobAll', {
          params: {
            gameName: row.gameName,
            scheduleIndex: row.scheduleIndex,
            id: row.taskId
          }
        }).then(response => {

          this.fetchTasks() ;
          console.log('删除任务成功:', response.data);

          this.$message.success('删除任务成功！');
        });

      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    },  async delRange(row) {
      try {
        const response = await axios.get(`/schedule/delRange?id=${row.rangeId}`);
        console.log('删除范围配置成功:', response.data);
        this.$message.success('删除范围配置成功！');

        // 刷新任务数据
        await this.fetchTasks();
      } catch (error) {
        console.error('删除范围配置失败:', error);
        this.$message.error('删除范围配置失败，请稍后重试');
      }
    },
    async submitAddOneClick() {
      try {
        const response = await axios.post('/schedule/addOneClick', this.oneClickFormData);
        console.log('添加一键配置任务成功:', response.data);
        this.$message.success('一键配置任务添加成功！');
      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    }, async submitSplitRequests() {
      try {
        // 拆分 taskFormData 为多个 oneClickFormData
        const oneClickForms = this.splitTaskFormDataToMultipleOneClick();

        // 逐个发送请求
        for (const formData of oneClickForms) {
          const response = await axios.post('/schedule/addOneClick', formData);
          console.log('提交成功:', response.data);
        }

        this.$message.success('所有任务提交成功！');
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error('任务提交失败，请稍后重试');
      }
    }, splitTaskFormDataToMultipleOneClick() {
      const result = [];

      // 遍历 rangeConfigs，为每个配置项生成一个 oneClickFormData
      this.taskFormData.rangeConfigs.forEach(config => {
        const oneClickFormData = {
          gameName: this.taskFormData.gameName,
          scheduleIndex: this.taskFormData.scheduleIndex,
          timeRange: this.taskFormData.timeRange,
          topPercentStart: config.topPercentStart,
          topPercentEnd: config.topPercentEnd,
          oneBeginCount: config.oneBeginCount,
          beginType: config.beginType
        };

        result.push(oneClickFormData);
      });

      return result;
    },
    async submitAddTask() {
      try {

        if(this.taskFormData.gameName=== ''|| this.taskFormData.scheduleIndex=== ''){
          this.$message.error('请填写完整信息！');
          return
        }

        if(this.taskFormData.timeRange==null){
          this.taskFormData.timeRange=''
        }
        this.taskFormData.gameName=this.taskFormData.gameName.trim();

        const response = await axios.post('/schedule/registerTask', this.taskFormData);
        console.log('添加一键配置任务成功:', response.data);
        this.$message.success('一键配置任务添加成功！');
        this.submitSplitRequests()
        this.findGame()
        this.dialogVisible = false;
      } catch (error) {
        console.error('添加一键配置任务失败:', error);
        this.$message.error('一键配置任务添加失败，请稍后重试');
      }
    }
    ,

    async fetchTasks() {
      try {
        // 并行发起两个请求
        const [response1, response2] = await Promise.all([
          axios.get('/schedule/getOneClick', { params: { gameName: this.valueGame } }),
          axios.get('/schedule/getTask', { params: { gameName: this.valueGame, configStatus: this.configStatus } })
        ]);

        // 初始化数据
        const task = response1.data?.data || [];
        const task2 = response2.data?.data || [];

        // 数据组合逻辑
        const result = [];

        task2.forEach(t => {
          // 尝试按照原始 scheduleIndex 匹配
          let matchedTaskList = task.filter(t2 => t2.scheduleIndex === t.scheduleIndex && t2.gameName === t.gameName);
          let isDefaultConfig = false; // 默认不使用默认配置
          // 如果未匹配到，则使用 scheduleIndex 为 1 的任务进行匹配
          if (matchedTaskList.length === 0) {
            matchedTaskList = task.filter(t2 => t2.scheduleIndex === 1&& t2.gameName === t.gameName);
            isDefaultConfig = true; // 标记为使用默认配置
          }

          if (matchedTaskList.length > 0) {
            // 主任务
            const mainTask = {
              taskId: t.id,
              gameName: t.gameName,
              timeRange: t.timeRange,
              scheduleIndex: t.scheduleIndex,
              scheduleStatus: t.scheduleStatus,
              filterMissingBalanceField: t.filterMissingBalanceField !== false,
              isDefaultConfig: isDefaultConfig, // 添加标记字段
              children: matchedTaskList.map(t2 => ({
                rangeId: t2.id,
                taskId: t2.id,
                topPercentStart: t2.topPercentStart,
                topPercentEnd: t2.topPercentEnd,
                oneBeginCount: t2.oneBeginCount,
                beginType: t2.beginType
              }))
            };
            this.applyTodayRunFields(mainTask, t);
            result.push(mainTask);
          } else {
            // 无匹配的主任务
            const mainTask = {
              taskId: t.id,
              scheduleStatus: t.scheduleStatus,
              gameName: t.gameName,
              timeRange: t.timeRange,
              scheduleIndex: t.scheduleIndex,
              filterMissingBalanceField: t.filterMissingBalanceField !== false,
              children: [],
              beginType: 0,
              isDefaultConfig: false
            };
            this.applyTodayRunFields(mainTask, t);
            result.push(mainTask);
          }
        });

        // 更新表格数据
        this.combinedTableData = result;

        console.log('组合后的数据:', result);
      } catch (error) {
        console.error('获取任务失败:', error);
        this.$message.error('获取任务失败，请稍后重试');
      }
    }, findGame() {

      this.$axios
          .get('/schedule/getTaskName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },   searchLogs() {
      this.currentPage = 1;
      this.findLogs();
    }, async findLogs() {
      try {
        const params = {
          gameName: this.valueGame,
          pageSize: this.pageSize
        };
        if (Array.isArray(this.logDateRange) && this.logDateRange.length === 2) {
          params.startDate = this.logDateRange[0];
          params.endDate = this.logDateRange[1];
        }
        const response = await this.$axios.get(`/schedule/getLogs/${this.currentPage}`, { params });
        const payload = response.data.data || {};
        if (Array.isArray(payload)) {
          this.logsData = payload;
          this.totalLogs = payload.length;
        } else {
          this.logsData = payload.records || [];
          this.totalLogs = payload.total || 0;
        }
        this.drawerVisible = true; // 打开抽屉
      } catch (error) {
        console.error('查询日志失败:', error);
        this.$message.error('查询日志失败，请稍后重试');
      }
    },addConfig(row){

      this.dialogVisible = true;
      this.taskFormData.timeRange=row.timeRange
      this.taskFormData.scheduleIndex=row.scheduleIndex
      this.taskFormData.gameName=row.gameName
      this.taskFormData.filterMissingBalanceField=row.filterMissingBalanceField !== false

    }
  , addRangeConfig() {
      this.taskFormData.rangeConfigs.push({
        topPercentStart: '',
        topPercentEnd: '',
        oneBeginCount: '',
        beginType: 0
      });
    },
    removeRangeConfig(index) {
      this.taskFormData.rangeConfigs.splice(index, 1);
    },
    formatNumber(value, digits = 2) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? value : numberValue.toFixed(digits);
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      return this.formatNumber(value, 2) + '%';
    },
    hasRangeConfig(row) {
      return row && Array.isArray(row.children) && row.children.length > 0;
    },
    hasScheduleTime(row) {
      return !!(row && row.timeRange && String(row.timeRange).length >= 2);
    },
    applyTodayRunFields(target, source) {
      target.todayRunStatus = source.todayRunStatus || '';
      target.todaySuccessCount = source.todaySuccessCount;
      target.todayFailedCount = source.todayFailedCount;
      target.todayTargetCount = source.todayTargetCount;
      target.todayTriggerType = source.todayTriggerType || '';
      target.todayStartTime = source.todayStartTime || '';
      target.todayEndTime = source.todayEndTime || '';
      target.todayErrorMessage = source.todayErrorMessage || '';
    },
    hasTodayOpenRecord(row) {
      return !!(row && row.todayRunStatus);
    },
    getTodayOpenText(row) {
      if (!this.hasTodayOpenRecord(row)) {
        if (!this.hasScheduleTime(row)) {
          return '-';
        }
        return this.isFutureSchedule(row) ? '待执行' : '未执行';
      }

      const successCount = Number(row.todaySuccessCount || 0);
      const failedCount = Number(row.todayFailedCount || 0);
      const targetCount = row.todayTargetCount === null || row.todayTargetCount === undefined
          ? successCount + failedCount
          : Number(row.todayTargetCount || 0);

      switch (row.todayRunStatus) {
        case 'QUEUED':
          return '排队中';
        case 'RUNNING':
          return '执行中';
        case 'PLATFORM_PROCESSING':
        case 'REQUEST_SUCCESS':
          return `腾讯处理中 ${Math.max(0, targetCount - failedCount)} 个`;
        case 'SUCCESS':
          return `成功 ${successCount} 个`;
        case 'PARTIAL_SUCCESS':
          return `部分成功 ${successCount}/${targetCount}`;
        case 'FAILED':
          return '失败';
        case 'NO_TARGET':
          return '无命中 0 个';
        default:
          return row.todayRunStatus;
      }
    },
    getTodayOpenTagType(row) {
      if (!this.hasTodayOpenRecord(row)) {
        if (!this.hasScheduleTime(row)) {
          return 'info';
        }
        return this.isFutureSchedule(row) ? 'info' : 'danger';
      }

      switch (row.todayRunStatus) {
        case 'SUCCESS':
          return 'success';
        case 'QUEUED':
        case 'RUNNING':
        case 'PLATFORM_PROCESSING':
        case 'REQUEST_SUCCESS':
        case 'PARTIAL_SUCCESS':
          return 'warning';
        case 'FAILED':
          return 'danger';
        case 'NO_TARGET':
          return 'info';
        default:
          return 'info';
      }
    },
    getTodayOpenTooltip(row) {
      if (!this.hasTodayOpenRecord(row)) {
        if (!this.hasScheduleTime(row)) {
          return '';
        }
        return this.isFutureSchedule(row) ? '计划时间未到' : '当天没有执行记录';
      }

      const parts = [];
      if (row.todayTriggerType === 'MANUAL') {
        parts.push('手动触发');
      } else if (row.todayTriggerType === 'SCHEDULE') {
        parts.push('定时触发');
      }
      if (row.todayRunStatus === 'QUEUED') {
        parts.push('状态：排队中');
      } else if (row.todayRunStatus === 'RUNNING') {
        parts.push('状态：执行中');
      } else if (row.todayRunStatus === 'PLATFORM_PROCESSING' || row.todayRunStatus === 'REQUEST_SUCCESS') {
        parts.push('状态：腾讯平台已受理，正在等待执行结果');
      }
      if (row.todayStartTime) {
        parts.push(`开始：${row.todayStartTime}`);
      }
      if (row.todayEndTime) {
        parts.push(`结束：${row.todayEndTime}`);
      }
      if (row.todayErrorMessage) {
        parts.push(`原因：${row.todayErrorMessage}`);
      }
      return parts.join('；');
    },
    isFutureSchedule(row) {
      if (!row || !row.timeRange) {
        return false;
      }
      const match = String(row.timeRange).match(/^(\d{1,2}):(\d{1,2})/);
      if (!match) {
        return false;
      }
      const now = new Date();
      const scheduleTime = new Date(now);
      scheduleTime.setHours(Number(match[1]), Number(match[2]), 0, 0);
      return scheduleTime.getTime() > now.getTime();
    },
    async openClick(row) {
      if (!this.hasRangeConfig(row)) {
        this.$message.warning('当前任务没有范围配置，不能手动开启');
        return;
      }

      this.openPreviewRow = row;
      this.openPreviewData = null;
      this.openExecuteResult = null;
      this.openPreviewVisible = true;
      this.openPreviewLoading = true;

      try {
        const response = await this.$axios.get('/schedule/previewTask', {
          params: {
            scheduleConfigId: row.taskId,
            gameName: row.gameName,
            scheduleIndex: row.scheduleIndex,
            timeRange: row.timeRange || ''
          }
        });
        const result = response.data || {};
        const previewData = result.data;

        if (!previewData) {
          throw new Error(result.msg || result.message || '预览失败');
        }

        if (previewData.status === 'FAILED') {
          throw new Error(previewData.errorMessage || '预览失败');
        }

        this.openPreviewData = previewData;
      } catch (error) {
        console.error('开启预览失败:', error);
        this.openPreviewVisible = false;
        this.$message.error('开启预览失败: ' + (error.message || '未知错误'));
      } finally {
        this.openPreviewLoading = false;
      }
    },
    async confirmOpenClick() {
      if (!this.openPreviewRow || this.openPreviewDetails.length === 0) {
        return;
      }

      this.openExecuteLoading = true;
      this.openExecuteResult = null;
      try {
        const response = await this.$axios.get('/schedule/triggerTask', {
          params: {
            scheduleConfigId: this.openPreviewRow.taskId,
            gameName: this.openPreviewRow.gameName,
            scheduleIndex: this.openPreviewRow.scheduleIndex,
            timeRange: this.openPreviewRow.timeRange || ''
          }
        });
        const result = response.data || {};
        const taskId = result.data;

        if (!taskId) {
          throw new Error(result.msg || result.message || '开启失败');
        }

        this.openExecuteResult = null;
        this.$message.success('开启任务已提交，任务ID: ' + taskId);
        this.openPreviewVisible = false;
        this.fetchTasks();
        this.pollTaskStatus(taskId, '开启');
      } catch (error) {
        console.error('开启失败:', error);
        this.$message.error('开启失败: ' + (error.message || '未知错误'));
      } finally {
        this.openExecuteLoading = false;
      }
    },
    async closeClick(row){
      this.closePreviewRow = row;
      this.closePreviewData = null;
      this.closePreviewVisible = true;
      this.closePreviewLoading = true;

      try {
        const response = await this.$axios.get(`/schedule/previewCloseAuto?id=${row.rangeId}`, {});
        const result = response.data || {};
        const previewData = result.data;

        if (!previewData) {
          throw new Error(result.msg || result.message || '预览失败');
        }

        if (previewData.status === 'FAILED') {
          throw new Error(previewData.errorMessage || '预览失败');
        }

        this.closePreviewData = previewData;
      } catch (error) {
        console.error('关闭预览失败:', error);
        this.closePreviewVisible = false;
        this.$message.error('关闭预览失败: ' + (error.message || '未知错误'));
      } finally {
        this.closePreviewLoading = false;
      }
    },
    async confirmCloseClick() {
      if (!this.closePreviewRow || this.closePreviewDetails.length === 0) {
        return;
      }

      this.closeExecuteLoading = true;
      try {
        const successResponse = await this.$axios.get(`/schedule/closeAuto?id=${this.closePreviewRow.rangeId}`, {});
        // 重构后返回任务ID，支持异步任务状态查询
        const taskId = successResponse.data?.data;
        if (taskId) {
          this.$message.success('关闭任务已提交！任务ID: ' + taskId);
          // 开始轮询任务状态
          this.pollTaskStatus(taskId, '关闭');
        } else {
          this.$message.success('关闭成功！');
        }
        this.closePreviewVisible = false;
        this.fetchTasks(); // 刷新任务列表
      } catch (error) {
        console.error('关闭失败:', error);
        this.$message.error('关闭失败: ' + (error.message || '未知错误'));
      } finally {
        this.closeExecuteLoading = false;
      }
    },

    // 轮询任务状态
    pollTaskStatus(taskId, actionName) {
      const pollIntervalMs = 10000;
      const maxAttempts = 360; // 最多查询约60分钟
      let attempts = 0;

      const checkStatus = () => {
        attempts++;
        this.$axios.get(`/schedule/getTaskStatus/${taskId}`)
            .then(response => {
              const status = response.data?.data;
              if (!status) {
                if (attempts < maxAttempts) {
                  setTimeout(checkStatus, pollIntervalMs);
                } else {
                  this.fetchTasks();
                  this.$message.warning('暂未查询到任务状态，后台可能仍在执行，请稍后刷新列表');
                }
                return;
              }

              switch (status.status) {
                case 'COMPLETED':
                  this.$message.success(actionName + '任务执行完成！');
                  this.fetchTasks(); // 完成后刷新列表
                  break;
                case 'FAILED':
                  this.$message.error(actionName + '任务执行失败: ' + (status.message || '未知错误'));
                  this.fetchTasks();
                  break;
                case 'RUNNING':
                case 'PROCESSING':
                case 'WAITING':
                  if (attempts < maxAttempts) {
                    if (attempts === 1 || attempts % 12 === 0) {
                      this.$message.info(actionName + '任务后台执行中... (' + (status.progress || 0) + '%)');
                    }
                    setTimeout(checkStatus, pollIntervalMs);
                  } else {
                    this.fetchTasks();
                    this.$message.warning(actionName + '任务仍在后台执行，请稍后刷新列表查看结果');
                  }
                  break;
                default:
                  if (attempts < maxAttempts) {
                    setTimeout(checkStatus, pollIntervalMs);
                  } else {
                    this.fetchTasks();
                    this.$message.warning('任务状态暂未更新，请稍后刷新列表');
                  }
              }
            })
            .catch(error => {
              console.error('查询任务状态失败:', error);
              if (attempts < maxAttempts) {
                setTimeout(checkStatus, pollIntervalMs);
              } else {
                this.fetchTasks();
                this.$message.error('任务状态查询失败，请稍后刷新列表');
              }
            });
      };

      // 开始轮询
      this.$message.info(actionName + '任务已进入后台执行');
      checkStatus();
    },

  },
  mounted() {
    // 页面加载时自动获取任务
    this.findGame()
    this.loadOperationMode()
    // this.fetchTasks();

  }
};
</script>
<template>
  <div>
    <template>
      <div class="bbb" style="margin-left: 10px">
        <h2>一键配置任务</h2>
        <div>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-top: 5px;align-items: center;width: 250px"
                     filterable clearable allow-create>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <el-select v-model="configStatus" placeholder="任务状态" size="mini"                     style="margin-top: 5px;margin-left: 5px;width: 120px"
                     filterable clearable>
<!--            <el-option label="全部" value=""></el-option>-->
            <el-option label="开启" :value="0"></el-option>
            <el-option label="关闭" :value="1"></el-option>
          </el-select>
          <el-button type="primary" @click="fetchTasks" style="width: 120px;margin-left: 5px" size="mini">查询
          </el-button>

          <el-button type="danger" @click="openAddTaskDialog" style="width: 120px" size="mini">添加任务</el-button>
          <span style="margin-left: 16px;color: #606266;font-size: 13px;">操作接口：</span>
          <el-tooltip content="仅影响之后新提交的任务，默认使用投放后台接口" placement="top">
            <el-switch
                v-model="operationMode"
                active-value="OFFICIAL"
                inactive-value="CONSOLE"
                active-text="腾讯官方API"
                inactive-text="投放后台接口"
                :disabled="operationModeSaving"
                @change="changeOperationMode">
            </el-switch>
          </el-tooltip>
          <el-date-picker
              v-model="logDateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="日志开始日期"
              end-placeholder="日志结束日期"
              size="mini"
              clearable
              style="width: 250px;margin-left: 5px">
          </el-date-picker>
          <el-button type="primary" @click="searchLogs" style="width: 120px;margin-left: 5px" size="mini">查询日志
          </el-button>

          <!-- 抽屉组件 -->
          <el-drawer
              title="日志详情"
              :visible.sync="drawerVisible"
              direction="rtl"
              size="60%"
          >
            <el-table :data="logsData" style="width: 100%" size="mini">
              <el-table-column prop="accountId" label="账户ID" width="130"></el-table-column>
              <el-table-column prop="advertiserId" label="广告主ID" width="120"></el-table-column>
              <el-table-column prop="beginCount" label="起量预算" width="100"></el-table-column>
              <el-table-column prop="gameName" label="游戏名称" width="250"></el-table-column>
              <el-table-column prop="miniGameRoi" label="小游戏ROI" width="120"></el-table-column>
              <el-table-column prop="statCost" label="消耗" width="100"></el-table-column>
              <el-table-column prop="uploadTime" label="操作时间" width="200"></el-table-column>
              <el-table-column prop="repData" label="原因/返回结果" min-width="320" show-overflow-tooltip></el-table-column>
              <el-table-column prop="reqData" label="规则/请求" min-width="260" show-overflow-tooltip></el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[ 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalLogs">
            </el-pagination>
          </el-drawer>
        </div>
        <div>
          <h3>已有配置任务</h3>
          <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
            <el-input
                v-model="searchKeyword"
                placeholder="请输入游戏名称搜索"
                prefix-icon="el-icon-search"
                size="mini"
                clearable                style="width: 250px;">
            </el-input>
          </div>
          <el-table
              :data="filteredTableData"
              size="mini"
              max-height="700"
              @expand-change="handleExpandChange"
          >
            <!-- 展开行 -->
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table :data="props.row.children" style="width: 100%" row-key="rangeId" size="mini">
                  <el-table-column prop="rangeId" label="范围id">

                  </el-table-column>
                  <el-table-column prop="topPercentStart" label="起始值">
                    <template slot-scope="scope">
                      {{ scope.row.beginType===0 ? scope.row.topPercentStart+'%' : scope.row.topPercentStart  }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="topPercentEnd" label="结束值">
                    <template slot-scope="scope">
                      {{ scope.row.beginType===0 ? scope.row.topPercentEnd+'%' : scope.row.topPercentEnd  }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="oneBeginCount" label="起量预算"></el-table-column>

                  <el-table-column prop="beginType" label="类型">
                    <template slot-scope="scope">
                      {{ scope.row.beginType === 0 ? 'ROI排行' : 'ROI范围' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="childScope">
                      <el-button type="danger" @click="delRange(childScope.row)" size="mini">删除范围</el-button>
<!--                      {{props.row.timeRange}}-->
                                            <el-button type="danger" v-show="!hasScheduleTime(props.row)" @click="closeClick(childScope.row)" size="mini">关闭一键起量</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <!-- 主任务列 -->
            <el-table-column prop="scheduleIndex" label="任务序号" width="150"></el-table-column>
            <el-table-column prop="gameName" label="游戏名称" width="280"></el-table-column>
            <el-table-column prop="timeRange" label="开启时间" width="150"></el-table-column>
            <el-table-column prop="filterMissingBalanceField" label="过滤缺少余额字段" width="150">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.filterMissingBalanceField ? 'warning' : 'info'">
                  {{ scope.row.filterMissingBalanceField ? '过滤' : '不过滤' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="configStatus" label="状态" width="150">
              <template slot-scope="scope">
    <span :class="scope.row.isDefaultConfig ? 'status-default' : scope.row.children.length>0?'status-success':'status-fail'">
      {{ scope.row.isDefaultConfig ? '默认配置' : (scope.row.children.length > 0 ? '配置成功' : '未配置') }}
    </span>
              </template>
            </el-table-column>
            <el-table-column label="今日开启" width="180">
              <template slot-scope="scope">
                <el-tooltip
                    :content="getTodayOpenTooltip(scope.row)"
                    placement="top"
                    :disabled="!getTodayOpenTooltip(scope.row)"
                >
                  <span>
                    <el-tag size="mini" :type="getTodayOpenTagType(scope.row)">
                      {{ getTodayOpenText(scope.row) }}
                    </el-tag>
                    <el-tag
                        v-if="scope.row.todayTriggerType === 'MANUAL'"
                        size="mini"
                        type="warning"
                        effect="plain"
                        style="margin-left: 4px;"
                    >
                      手动
                    </el-tag>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 操作列 -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="primary" @click="delJob(scope.row)" size="mini">删除任务</el-button>

                <el-button type="danger" @click="delJobAll(scope.row)" size="mini">删除任务及范围</el-button>

                <el-button type="success" @click="addConfig(scope.row)" size="mini" icon="el-icon-circle-plus-outline">添加范围配置</el-button>

                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-video-play"
                    :disabled="!hasRangeConfig(scope.row) || openPreviewLoading || openExecuteLoading"
                    @click="openClick(scope.row)"
                >
                  手动开启
                </el-button>

                <!-- 根据 scheduleStatus 显示开启/关闭按钮 -->
                <el-button
                    :type="scope.row.scheduleStatus === 0 ? 'danger' : 'success'"
                    @click="toggleSchedule(scope.row)"
                    size="mini"
                >
                  {{ scope.row.scheduleStatus === 0 ? '关闭' : '开启' }}
                </el-button>
              </template>
            </el-table-column>


          </el-table>

          <div style="margin-top: 10px; text-align: left; color: #666; font-size: 14px;">
            共 {{ filteredTableData.length }} 条记录
          </div>
        </div>
      </div>

      <el-dialog
          title="开启一键起量确认"
          :visible.sync="openPreviewVisible"
          width="900px"
          :close-on-click-modal="false"
      >
        <div v-loading="openPreviewLoading">
          <div v-if="openPreviewData" style="margin-bottom: 12px; color: #606266; font-size: 14px;">
            游戏：{{ openPreviewData.gameName }}，
            任务序号：{{ openPreviewData.scheduleIndex }}，
            活跃账户：{{ openPreviewData.totalAccounts || 0 }}，
            广告组总数：{{ openPreviewData.totalAdGroups || 0 }}，
            命中目标：{{ openPreviewDetails.length }}
          </div>

          <el-alert
              v-if="openPreviewData && openPreviewDetails.length === 0"
              title="当前规则没有命中需要开启的目标"
              type="warning"
              :closable="false"
              show-icon
              style="margin-bottom: 12px;"
          />

          <el-alert
              v-if="openExecuteResult"
              :title="openExecuteSummary"
              :type="openExecuteAlertType"
              :closable="false"
              show-icon
              style="margin-bottom: 12px;"
          />

          <el-table
              :data="openExecuteDetails.length > 0 ? openExecuteDetails : openPreviewDetails"
              size="mini"
              max-height="420"
              border
              style="width: 100%;"
          >
            <el-table-column prop="accountId" label="账户ID" width="150"></el-table-column>
            <el-table-column prop="adGroupId" label="广告组ID" width="160"></el-table-column>
            <el-table-column prop="roi" label="ROI" width="100">
              <template slot-scope="scope">
                {{ formatNumber(scope.row.roi, 4) }}
              </template>
            </el-table-column>
            <el-table-column prop="cost" label="消耗" width="100">
              <template slot-scope="scope">
                {{ formatNumber(scope.row.cost, 2) }}
              </template>
            </el-table-column>
            <el-table-column prop="rankPercent" label="排名百分比" width="120">
              <template slot-scope="scope">
                {{ formatPercent(scope.row.rankPercent) }}
              </template>
            </el-table-column>
            <el-table-column prop="beginCount" label="起量预算" width="120"></el-table-column>
            <el-table-column v-if="openExecuteResult" prop="success" label="执行结果" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.success ? 'success' : 'danger'" size="mini">
                  {{ scope.row.success ? '成功' : '失败' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column v-if="openExecuteResult" prop="errorMessage" label="失败原因"></el-table-column>
          </el-table>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="openPreviewVisible = false" size="mini">取消</el-button>
          <el-button
              type="warning"
              size="mini"
              :loading="openExecuteLoading"
              :disabled="openPreviewLoading || openExecuteLoading || openPreviewDetails.length === 0 || !!openExecuteResult"
              @click="confirmOpenClick"
          >
            确认开启
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
          title="关闭一键起量确认"
          :visible.sync="closePreviewVisible"
          width="900px"
          :close-on-click-modal="false"
      >
        <div v-loading="closePreviewLoading">
          <div v-if="closePreviewData" style="margin-bottom: 12px; color: #606266; font-size: 14px;">
            游戏：{{ closePreviewData.gameName }}，
            任务序号：{{ closePreviewData.scheduleIndex }}，
            活跃账户：{{ closePreviewData.totalAccounts || 0 }}，
            广告组总数：{{ closePreviewData.totalAdGroups || 0 }}，
            命中目标：{{ closePreviewDetails.length }}
          </div>

          <el-alert
              v-if="closePreviewData && closePreviewDetails.length === 0"
              title="当前规则没有命中需要关闭的目标"
              type="warning"
              :closable="false"
              show-icon
              style="margin-bottom: 12px;"
          />

          <el-table
              :data="closePreviewDetails"
              size="mini"
              max-height="420"
              border
              style="width: 100%;"
          >
            <el-table-column prop="accountId" label="账户ID" width="150"></el-table-column>
            <el-table-column prop="adGroupId" label="广告组ID" width="160"></el-table-column>
            <el-table-column prop="roi" label="ROI" width="100">
              <template slot-scope="scope">
                {{ formatNumber(scope.row.roi, 4) }}
              </template>
            </el-table-column>
            <el-table-column prop="cost" label="消耗" width="100">
              <template slot-scope="scope">
                {{ formatNumber(scope.row.cost, 2) }}
              </template>
            </el-table-column>
            <el-table-column prop="rankPercent" label="排名百分比" width="120">
              <template slot-scope="scope">
                {{ formatPercent(scope.row.rankPercent) }}
              </template>
            </el-table-column>
            <el-table-column prop="beginCount" label="起量预算"></el-table-column>
          </el-table>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="closePreviewVisible = false" size="mini">取消</el-button>
          <el-button
              type="danger"
              size="mini"
              :loading="closeExecuteLoading"
              :disabled="closePreviewLoading || closePreviewDetails.length === 0"
              @click="confirmCloseClick"
          >
            确认关闭
          </el-button>
        </span>
      </el-dialog>

      <!-- 添加任务的对话框 -->
      <el-dialog title="添加任务" :visible.sync="dialogVisible" width="1000px">
        <el-form :model="taskFormData" label-width="100px">
          <!-- 游戏名称 -->
          <el-form-item label="标签名称">
            <el-select v-model="taskFormData.gameName" placeholder="游戏标签可自定义-xxxx" required filterable allow-create style="width: 280px"
                       clearable>
              <el-option
                  v-for="item in optionsGame2"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 任务序号 -->
          <el-form-item label="任务序号">
            <el-input v-model="taskFormData.scheduleIndex" required style="width: 200px"/>
          </el-form-item>

          <!-- 开启时间 -->
          <el-form-item label="开启时间">
            <el-time-picker
                v-model="taskFormData.timeRange"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="请选择时间"
                required
            />
          </el-form-item>

          <el-form-item label="余额字段">
            <el-switch
                v-model="taskFormData.filterMissingBalanceField"
                active-text="过滤缺少 balance 的账号"
                inactive-text="不过滤"
            />
            <div style="font-size: 12px; color: #909399; line-height: 20px; margin-top: 4px;">
              开启后，腾讯账号日报没有返回 balance 字段的账号会被排除；关闭后仍按日预算等条件判断。
            </div>
          </el-form-item>

          <!-- 范围配置（动态添加） -->
          <el-form-item label="范围配置">
            <div v-for="(config, index) in taskFormData.rangeConfigs" :key="index" style="margin-bottom: 10px;">
              <el-input
                  v-model="config.topPercentStart"
                  :placeholder="config.beginType === 0 ? '起始百分比10' : '起始小数点0.1'" style="width: 20%; margin-right: 10px;"
                  required

              />
              <el-input
                  v-model="config.topPercentEnd"
                  :placeholder="config.beginType === 0 ? '结束百分比10' : '结束小数点0.1'"  style="width: 20%; margin-right: 10px;"
                  required
              />
              <el-input
                  v-model="config.oneBeginCount"
                  placeholder="起量预算" style="width: 30%;"
                  required
              />

              <!-- beginType 选择器 -->
              <el-select
                  v-model="config.beginType"
                  placeholder="选择类型"        style="width: 20%; margin-left: 10px;"
                  required
              >
                <el-option label="ROI排行" :value="0"></el-option>
                <el-option label="ROI范围" :value="1"></el-option>
              </el-select>
              <el-button @click="removeRangeConfig(index)" type="danger" style="margin-left: 5px" icon="el-icon-delete"
                         circle></el-button>
            </div>
            <el-button @click="addRangeConfig" type="primary" icon="el-icon-plus">添加范围</el-button>
          </el-form-item>

          <!-- 提交按钮 -->
          <el-form-item>
            <el-button type="primary" @click="submitAddTask" style="width: 100px">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </template>

  </div>
</template>
